// Hints
// Features:
// - Container for all UI hints (Camera, Controller, Hide toggle)
// - Simply aggregates sub-components

import ControllerHint from './Hints/ControllerHint'
import CameraHint from './Hints/CameraHint'
import HideHint from './Hints/HideHint'

export default function Hints() {
    return (
        <>
            <CameraHint />
            <ControllerHint />
            <HideHint />
        </>
    )
}
